export { default } from './category-hierarchy.vue'
